module.exports = __webpack_public_path__ + "static/logo-p4tp-dark-2e9184c24983d96feab8913db988e0e8.png";